import {connect} from "react-redux";
import {Tooltip} from "bootstrap";
import AppBaseComponent from '../../components/AppBaseComponent';
import HttpAPICall from "../../services/HttpAPICall";
import Loader from "../../components/ui/Loader/Loader";
import TapSelect from "../../components/ui/TapSelect";
import tapIcon from "../../services/TapIcon";
import Ax from "../../components/hoc/Ax"
import React from "react";
import TapApiUrls, { INVENTORY_API_BASE_URL_2 } from "../../services/TapApiUrls";
import { toast } from "react-toastify";
import moment from "moment";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import AllocationDetailItemWise from "../inventory/allocation/AllocationDetailItemWise";
import TransferItemWiseListModal from "../inventory/inventoryTransfer/TransferItemWiseListModal";


class ItemInventory extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.state                  =           {
            itemId                  :               this.props.item_enc_id,
            itemName                :               this.props.itemName || '',
            listing_tbl_page        :               1,
            listingData             :               [],
            listingMeta             :               [],
            totalListingCount       :               0,
            listing_loading         :               false,
            isc_configuration       :               null,
            expandedRows            :               [], // NEW: Tracks which warehouses are open
        }

        this.itemWiseAllocationRef      =   React.createRef();
        this.itemWiseInventoryRef       =   React.createRef();
        this.itemCurrentStockUrl        =   INVENTORY_API_BASE_URL_2 + '/item_current_stock';
    }

    componentDidMount() {
         if (this.props.item_enc_id) {
            this.loadListingTblData(this.props.item_enc_id);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.item_enc_id !== this.props.item_enc_id) {
            this.setState({ 
                itemId: this.props.item_enc_id,
                itemName: this.props.itemName || '',
                expandedRows: [] // NEW: Reset arrows when item changes
            }, () => {
                this.loadListingTblData(this.props.item_enc_id);
            });
        }
        if (this.props.refreshInventoryLevel === true && 
            prevProps.refreshInventoryLevel !== this.props.refreshInventoryLevel) {
            this.refreshInventoryLevel(this.props.item_enc_id);
        }
    }
    
    loadListingTblData = (id) => {
        if (!id) return;
        
        this.setState({listing_loading: true});
        HttpAPICall.withAthorization(
            'GET', 
            this.itemCurrentStockUrl + '/' + id, 
            this.props.access_token, 
            {interchangeable_items_current_stock: "Y"}, 
            {}, 
            (resp) => {
                this.setState({
                    listingData: resp.data,
                });
            }
        ).finally(() => this.setState({listing_loading: false}));
    }

    refreshInventoryLevel = (id) => {
        if (!id) return;
        
        this.setState({listing_loading: true});
        HttpAPICall.withAthorization(
            'PUT', 
            this.itemCurrentStockUrl + '/' + id, 
            this.props.access_token, 
            {}, 
            {}, 
            (resp) => {
                this.loadListingTblData(id);
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
            }
        ).finally(() => this.setState({listing_loading: false}));
    }

    // NEW: Logic to group raw data by warehouse
    getGroupedStock = (data) => {
        if (!data) return [];
        const groups = {};

        data.forEach(item => {
            const wId = item.warehouse_id;
            if (!groups[wId]) {
                groups[wId] = {
                    warehouse: item.warehouse,
                    warehouse_id: item.warehouse_id,
                    total_qty: 0,
                    on_hold: 0,
                    allocated_qty: 0,
                    intransit: 0,
                    free_qty: 0,
                    subItems: []
                };
            }
            groups[wId].total_qty += parseFloat(item.total_qty || 0);
            groups[wId].on_hold += parseFloat(item.on_hold || 0);
            groups[wId].allocated_qty += parseFloat(item.allocated_qty || 0);
            groups[wId].intransit += parseFloat(item.intransit || 0);
            groups[wId].free_qty += parseFloat(item.free_qty || 0);
            groups[wId].subItems.push(item);
        });

        return Object.values(groups);
    }

    // NEW: Handle arrow click
    toggleRow = (warehouseId) => {
        const { expandedRows } = this.state;
        if (expandedRows.includes(warehouseId)) {
            this.setState({ expandedRows: expandedRows.filter(id => id !== warehouseId) });
        } else {
            this.setState({ expandedRows: [...expandedRows, warehouseId] });
        }
    }
    
    // Existing logic preserved
    changeTab = (key) => {
        if (this.props.history) {
            let ParamObject = new URLSearchParams(this.props.location?.search);
            let itemName, itemCategory;
            if (ParamObject.get('item_name')) { itemName = ParamObject.get('item_name'); }
            if (ParamObject.get('item_category')) { itemCategory = ParamObject.get('item_category'); }
            let obj = {item_name: itemName, item_category: itemCategory};
            this.props.history.push({ 
                pathname: `/item_list/${key}/${this.state.itemId}`, 
                search: "?" + new URLSearchParams(obj).toString()
            });
        }
    }

    allocationDetailInit = (item_id = '', warehouse_name, warehouse_id) => {
        let itemName = this.state.itemName;
        if (this.props.location) {
            let ParamObject = new URLSearchParams(this.props.location.search);
            if (ParamObject.get('item_name')) { itemName = ParamObject.get('item_name'); }
        }
        this.itemWiseAllocationRef.current?.modalInit(item_id, itemName, warehouse_name, warehouse_id);
    }

    inventoryTransferDetailInit = (item_id = '', warehouse_id) => {
        let itemName = this.state.itemName;
        if (this.props.location) {
            let ParamObject = new URLSearchParams(this.props.location.search);
            if (ParamObject.get('item_name')) { itemName = ParamObject.get('item_name'); }
        }
        let data = {id: item_id, name: itemName};
        this.itemWiseInventoryRef.current?.modalInit(data, '', '', warehouse_id, 35);
    }

    render() {
        const { hideHelmet, category } = this.props;
        const { listingData, listing_loading, expandedRows } = this.state;
        
        return (
            <Ax>
                {!hideHelmet && <Helmet><title>Item - Inventory Levels</title></Helmet>}
                
                <section className="item_view_container bg-white">
                    {category == "goods" ? (
                        <div className="tab_content_header">
                            <table className="table table-hover table-bordered table-responsive bg-white my-3">
                                <thead className="table-secondary">
                                    <tr className="text-end">
                                        <th style={{ width: '5%' }} className="text-center">S.No</th>
                                        <th style={{ width: "25%" }} className="text-start">Warehouse</th>
                                        {this.props.isc_configuration?.track_batch_expiry === "Y" ? (
                                            <Ax>
                                                <th style={{ width: "15%" }} className="text-start">Batch Number</th>
                                                <th style={{ width: "15%" }} className="text-center">Expiry Date</th>
                                            </Ax>
                                        ) : null}
                                        <th style={{ width: "8%" }}>Total Qty</th>
                                        <th style={{ width: "8%" }}>On Hold</th>
                                        <th style={{ width: "8%" }}>Allocated</th>
                                        <th style={{ width: "8%" }}>In Transit</th>
                                        <th style={{ width: "8%" }}>Free Stock</th>
                                    </tr>
                                </thead>
                              <tbody>
                                    {listing_loading ? (
                                        <tr><td colSpan={this.props.isc_configuration?.track_batch_expiry === "Y" ? 9 : 7}><Loader /></td></tr>
                                    ) : (
                                        this.getGroupedStock(listingData?.current_stock).length > 0 ? (
                                            this.getGroupedStock(listingData.current_stock).map((group, k) => {
                                                const isExpanded = expandedRows.includes(group.warehouse_id);
                                                const hasSubItems = group.subItems.length > 1;
                                                // Calculate how many rows this warehouse should span
                                                const rowSpanCount = (hasSubItems && isExpanded) ? group.subItems.length + 1 : 1;

                                                return (
                                                    <React.Fragment key={group.warehouse_id}>
                                                        {/* Summary Row */}
                                                        <tr className="text-end">
                                                            <td className="text-center" rowSpan={rowSpanCount} style={{ verticalAlign: 'middle' }}>{k + 1}</td>
                                                            <td className="text-start" rowSpan={rowSpanCount} style={{ verticalAlign: 'middle' }}>
                                                                <b>{group.warehouse?.name || "-"}</b> 
                                                                {group.warehouse?.code && <span> ({group.warehouse.code})</span>}
                                                            </td>
                                                            {this.props.isc_configuration?.track_batch_expiry === "Y" ? (
                                                                <td colSpan="2" className="text-center text-muted small cursor_pointer" onClick={() => this.toggleRow(group.warehouse_id)}>
                                                                     {hasSubItems && (
                                                                        <span className="me-2">
                                                                            <tapIcon.FontAwesomeIcon icon={isExpanded ? tapIcon.faCaretUp : tapIcon.faCaretDown} />
                                                                        </span>
                                                                    )} 
                                                                    {hasSubItems ? "Multiple Batches" : (group.subItems[0]?.batch_number || "-")}
                                                                </td>
                                                            ) : null}
                                                            <td><b>{group.total_qty}</b></td>
                                                            <td>{group.on_hold}</td>
                                                            <td>{group.allocated_qty}</td>
                                                            <td>{group.intransit}</td>
                                                            <td><b>{group.free_qty}</b></td>
                                                        </tr>

                                                        {/* Detailed Sub-Rows */}
                                                        {hasSubItems && isExpanded && group.subItems.map((sub, sk) => (
                                                            <tr key={`${group.warehouse_id}-${sk}`} className="text-end small table-sm">
                                                                {/* S.No and Warehouse cells are omitted here because of rowSpan above */}
                                                                {this.props.isc_configuration?.track_batch_expiry === "Y" ? (
                                                                    <Ax>
                                                                        <td className="text-start">{sub.batch_number || "-"}</td>
                                                                        <td className="text-center">
                                                                            {sub.expiry_date ? moment(sub.expiry_date).format("DD-MMM-YYYY") : "-"}
                                                                        </td>
                                                                    </Ax>
                                                                ) : null}
                                                                <td>{sub.total_qty}</td>
                                                                <td>{sub.on_hold}</td>
                                                                <td
                                                                    className="link-primary cursor_pointer"
                                                                    onClick={() => this.allocationDetailInit(sub.item_id, group.warehouse?.name, sub.warehouse_id)}
                                                                >
                                                                    {sub.allocated_qty}
                                                                </td>
                                                                <td
                                                                    className="link-primary cursor_pointer"
                                                                    onClick={() => this.inventoryTransferDetailInit(sub.item_id, sub.warehouse_id)}
                                                                >
                                                                    {sub.intransit}
                                                                </td>
                                                                <td>{sub.free_qty}</td>
                                                            </tr>
                                                        ))}
                                                    </React.Fragment>
                                                )
                                            })
                                        ) : (
                                            <tr><td colSpan={this.props.isc_configuration?.track_batch_expiry === "Y" ? 9 : 7} className="text-center">No Records</td></tr>
                                        )
                                    )}
                                </tbody>
                            </table>

                            {/* Interchangeable Section remains unchanged */}
                            <div className="tab_content_wrapper">
                                <span className="content_heading">Interchangeable</span>
                            </div>
                            
                            <table className="table table-hover table-bordered table-responsive bg-white my-3">
                                <thead className="table-secondary">
                                    <tr className="text-end">
                                        <th style={{ width: '5%' }} className="text-center">S.No</th>
                                        <th style={{ width: "24%" }} className="text-start">Item</th>
                                        <th style={{ width: "15%" }} className="text-start">Warehouse</th>
                                        {this.props.isc_configuration?.track_batch_expiry === "Y" ? (
                                            <Ax>
                                                <th style={{ width: "8%" }} className="text-start">Batch Number</th>
                                                <th style={{ width: "8%" }} className="text-center">Expiry Date</th>
                                            </Ax>
                                        ) : null}
                                        <th style={{ width: "8%" }}>Total Qty</th>
                                        <th style={{ width: "8%" }}>On Hold</th>
                                        <th style={{ width: "8%" }}>Allocated</th>
                                        <th style={{ width: "8%" }}>In Transit</th>
                                        <th style={{ width: "8%" }}>Free Stock</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listing_loading ? (
                                        <tr><td colSpan={this.props.isc_configuration?.track_batch_expiry === "Y" ? 10 : 8}><Loader /></td></tr>
                                    ) : (listingData?.interchangable?.length > 0 ? (
                                        listingData.interchangable.map((item, k) => (
                                            <tr key={k} className="text-end">
                                                <td className="text-center">{k + 1}</td>
                                                <td className="text-start text-capitalize">
                                                    {item.item ? item.item.name : "-"} <br />
                                                    <small>Code: {item.item ? item.item.item_code : "-"}</small><br/>
                                                    <small>Mfr: <b>{item?.item?.manufacturer?.name || '-'}</b> (MPN: <b>{item?.item?.manufacturer_part_no || '-'}</b>)</small>
                                                </td>
                                                <td className="text-start">{item.warehouse ? item.warehouse.name : "-"}</td>
                                                {this.props.isc_configuration?.track_batch_expiry === "Y" ? (
                                                    <Ax>
                                                        <td className="text-start">{item.batch_number || "-"}</td>
                                                        <td className="text-center">{item.expiry_date ? moment(item.expiry_date).format("DD-MMM-YYYY") : "-"}</td>
                                                    </Ax>
                                                ) : null}
                                                <td>{item.total_qty || "0"}</td>
                                                <td>{item.on_hold || "0"}</td>
                                                <td className="link-primary cursor_pointer" onClick={() => this.allocationDetailInit(item.item_id, item?.warehouse?.name, item.warehouse_id)}>
                                                    {item.allocated_qty || "0"}
                                                </td>
                                                <td className="link-primary cursor_pointer" onClick={() => this.inventoryTransferDetailInit(item.item_id, item.warehouse_id)}>
                                                    {item.intransit || "0"}
                                                </td>
                                                <td>{item.free_qty || "0"}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr><td colSpan={this.props.isc_configuration?.track_batch_expiry === "Y" ? 10 : 8} className="text-center">No Records</td></tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="tab_content_header">
                            <div className="text-center p-5">
                                <p className="text-muted">Inventory levels are not applicable for service items.</p>
                            </div>
                        </div>
                    )}
                </section>
                
                <TransferItemWiseListModal ref={this.itemWiseInventoryRef}/>
                <AllocationDetailItemWise ref={this.itemWiseAllocationRef}/>
            </Ax>
        );
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token,
        isc_configuration: state.app?.isc_configuration || null,
    };
};

export default connect(mapStateToProps)(ItemInventory);